import React, { MouseEvent } from 'react';
import styled from '@emotion/styled';
import ButtonBase from '@base/Button/Button';
import {
  UN_ICONS_BUTTON_COLOR,
  UN_ICONS_BUTTON_MAX_HEIGHT,
  UN_ICONS_BUTTON_TYPE,
  UN_ICONS_BUTTON_VARIANT
} from 'types/unacademyIcons/button.type';
import { Spacings } from '@styles/index';

interface ButtonProps {
  variant?: UN_ICONS_BUTTON_VARIANT;
  color?: UN_ICONS_BUTTON_COLOR;
  bgColor?: string;
  width?: string;
  icon?: React.ReactNode | null;
  maxHeight?: UN_ICONS_BUTTON_MAX_HEIGHT | null;
  grid?: number;
  className?: string;
  children: React.ReactNode;
  onClick?: (e: MouseEvent<HTMLElement>) => void;
  onMouseEnter?: (e: MouseEvent<HTMLButtonElement>) => void;
  onMouseLeave?: (e: MouseEvent<HTMLButtonElement>) => void;
  type?: UN_ICONS_BUTTON_TYPE;
  dataAnalytics?: string;
}

type BaseButtonProps = {
  $bgColor: string;
};

const ButtonComp = ButtonBase as any;

const StyledButton = styled(ButtonComp)<BaseButtonProps>`
  background-color: ${({ $bgColor }) => $bgColor || 'var(--color-i-icon-gold)'};
  &:hover {
    box-shadow: ${({ variant }) =>
      variant !== 'disabled' &&
      `${Spacings.SPACING_0B} ${Spacings.SPACING_4B} ${Spacings.SPACING_8B} ${Spacings.SPACING_0B} var(--color-i-icon-shadow)`};
    transform: ${({ variant }) =>
      variant !== 'disabled' && 'translate(0px, -2px)'};
    border-color: ${({ variant }) =>
      variant === 'hollow' && 'var(--color-divider)'};
    ${({ variant }) =>
      variant === 'hollow' ? 'background-color: var(--color-divider);' : ''}
  }
`;

const Button: React.FC<ButtonProps> = ({ children, ...props }) => {
  const {
    className,
    color,
    variant,
    width,
    grid,
    icon,
    type,
    bgColor,
    dataAnalytics,
    onClick
  } = props;

  return (
    <StyledButton
      type={type}
      className={className}
      width={width}
      dataAnalytics={dataAnalytics}
      color={color}
      variant={variant}
      label={children}
      $bgColor={bgColor}
      grid={grid}
      onClick={variant === UN_ICONS_BUTTON_VARIANT.DISABLED ? null : onClick}
      icon={icon}
    />
  );
};

Button.displayName = 'Button';

Button.defaultProps = {
  variant: UN_ICONS_BUTTON_VARIANT.FILLED,
  color: UN_ICONS_BUTTON_COLOR.GOLD,
  bgColor: 'var(--color-i-icon-gold)',
  className: '',
  icon: null,
  grid: 4,
  maxHeight: null,
  onClick: () => {},
  onMouseEnter: () => {},
  onMouseLeave: () => {},
  type: UN_ICONS_BUTTON_TYPE.BUTTON,
  dataAnalytics: ''
};

export default Button;
